import { Dialog, Text } from '@loadsmart/loadsmart-ui'

import { plural } from 'core/utils/string'

export type BulkConfirmSubmissionDialogProps = {
  ratesToSubmitCount: number
  onConfirm: () => void
  onCancel: () => void
}

export function BulkConfirmSubmissionDialog({
  ratesToSubmitCount,
  onConfirm,
  onCancel,
}: BulkConfirmSubmissionDialogProps) {
  const headerText = `Submitting ${ratesToSubmitCount} ${plural('rate', ratesToSubmitCount)}`
  return (
    <Dialog onOverlayClick={onCancel} scale="small" open>
      <Dialog.Header>{headerText}</Dialog.Header>
      <Dialog.Body>
        <Text>Submitted rates cannot be edited</Text>
      </Dialog.Body>
      <Dialog.ActionConfirm onConfirm={onConfirm}>Confirm</Dialog.ActionConfirm>
      <Dialog.ActionCancel onCancel={onCancel}>Cancel</Dialog.ActionCancel>
    </Dialog>
  )
}
